import { RightCircleFilled } from '@ant-design/icons';
import { Row, Select } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import FloatLabel from '~/components/Form/FloatLabel';
import colors from '~/constants/colors';
import { capitalizeWords } from '~/utils/validateCharacters';

type FormSection = {
  branch?: string;
  cardholder?: string;
  company?: string;
  department?: string;
  region?: string;
};

type FormValues = {
  [key: string]: FormSection;
};

function SelectInputTree(props: any): React.ReactElement {
  const { ele, item, productList, form, Form, productKey } = props;
  const globeState = useSelector((state: any) => state.state);
  const { panelError = {} } = globeState;
  const { t } = useTranslation();
  const selectValue = form?.getFieldValue([`${item}-section`, ele]);
  const productObj = { productKey };

  return (
    <Row key={`${ele}-ele`}>
      <Form.Item
        noStyle
        shouldUpdate={(prevValues: FormValues, currentValues: FormValues) => {
          const prevSection = prevValues?.[`${item}-section`] || {};
          const currentSection = currentValues?.[`${item}-section`] || {};
          return JSON.stringify(prevSection) !== JSON.stringify(currentSection);
        }}
      >
        {() => {
          const sectionValues = form.getFieldsValue()[`${item}-section`] || {};
          const preParentId = Object.entries({ ...productObj, ...sectionValues })
            .filter((ele: any) => !ele?.includes(item))
            .flat()
            .join('-');
          const indexOfelement = preParentId.indexOf(ele);
          const finalParentId = preParentId.substring(0, indexOfelement - 1)
            ? preParentId.substring(0, indexOfelement - 1)
            : null;
          const options = productList
            ?.filter((op: any) => op.parentId === finalParentId)
            ?.map((dw: any) => {
              return { ...dw, title: dw?.name, label: dw?.name, value: dw?.name };
            });

          return (
            <Form.Item
              style={{ margin: '0px', padding: '0px', marginBottom: '10px', maxWidth: '170px', minWidth: '170px' }}
              name={[`${item}-section`, ele]}
            >
              <FloatLabel label={capitalizeWords(t(`${ele}`))} key={`${ele}-ele`}>
                <Select
                  key={`${selectValue}-${item}-${ele}-select`}
                  status={panelError?.[`${item}-section`]?.includes(ele) && !selectValue ? 'error' : undefined}
                  disabled={ele === 'company'}
                  allowClear
                  options={options}
                  style={{ minWidth: '120px' }}
                />
              </FloatLabel>
            </Form.Item>
          );
        }}
      </Form.Item>
      {ele !== 'department' && (
        <RightCircleFilled
          style={{ marginLeft: '4px', marginRight: '-4px', marginTop: '-8px', color: colors.blue[800] }}
        />
      )}
      {panelError?.[`${item}-section`]?.includes(ele) && !selectValue && (
        <p
          key={`${selectValue}-${item}-${ele}-selectText`}
          style={{ position: 'absolute', bottom: -19, left: '15%', width: '300px', color: colors.red[1100] }}
        >
          Required
        </p>
      )}
    </Row>
  );
}
export default SelectInputTree;
